import { OrderStatus } from '@/api/orders';

function OrderStatusRender({ status }: { status: OrderStatus }) {
  const statusMap = {
    [OrderStatus.NEW]: {
      label: 'Mới',
      className: 'bg-blue-100 text-blue-800',
    },
    [OrderStatus.PENDING]: {
      label: 'Chờ duyệt',
      className: 'bg-yellow-100 text-yellow-800',
    },
    [OrderStatus.BUSINESS_APPROVED]: {
      label: 'Quản lý đã duyệt',
      className: 'bg-blue-100 text-blue-800',
    },
    [OrderStatus.ACCOUNTING_APPROVED]: {
      label: 'Kế toán đã duyệt',
      className: 'bg-green-100 text-green-800',
    },
    [OrderStatus.ADMIN_APPROVED]: {
      label: 'Admin đã duyệt',
      className: 'bg-purple-100 text-purple-800',
    },
    [OrderStatus.GENERAL_DIRECTOR_APPROVED]: {
      label: 'Giám đốc đã duyệt',
      className: 'bg-indigo-100 text-indigo-800',
    },
    [OrderStatus.BUSINESS_REJECTED]: {
      label: 'Quản lý đã từ chối',
      className: 'bg-red-100 text-red-800',
    },
    [OrderStatus.ACCOUNTING_REJECTED]: {
      label: 'Kế toán đã từ chối',
      className: 'bg-red-100 text-red-800',
    },
    [OrderStatus.ADMIN_REJECTED]: {
      label: 'Admin đã từ chối',
      className: 'bg-red-100 text-red-800',
    },
    [OrderStatus.GENERAL_DIRECTOR_REJECTED]: {
      label: 'Giám đốc đã từ chối',
      className: 'bg-red-100 text-red-800',
    },
    [OrderStatus.APPROVED]: {
      label: 'Đã duyệt',
      className: 'bg-green-100 text-green-800',
    },
    [OrderStatus.REJECTED]: {
      label: 'Đã từ chối',
      className: 'bg-red-100 text-red-800',
    },
  };
  return (
    <div
      className={`min-w-30 text-center px-2 py-1 rounded-full text-sm font-medium inline-block ${statusMap[status].className}`}
    >
      {statusMap[status].label}
    </div>
  );
}

export default OrderStatusRender;
